import React from "react";
import { StaticImage } from "gatsby-plugin-image";

import ButtonSolid from "../Button/ButtonSolid";

const HomeStopLosingLeads = ({ headingLevel, className }) => {
  const HeadingTag = headingLevel || "h2";

  return (
    <section className={`${className || "mb-20 md:mb-32"}`}>
      <div className="container mx-auto max-w-[1267px]">
        <div className="grid items-center gap-y-8 md:grid-cols-2 md:gap-x-10 lg:gap-x-20">
          <div className="order-2 md:order-last">
            <HeadingTag>Don’t Let Bad Lead Sources Drain Your ROI</HeadingTag>
            <p>
              Realsynch’s business intelligence software equips you with the
              tools to boost lead generation, increase conversions, and enhance
              agent performance. Dive deep into your leads with powerful
              insights like:
            </p>
            <ul className="mb-10 flex flex-col gap-y-2">
              <li className="flex gap-x-[11px]">
                <StaticImage
                  src="../../images/1.0 Homepage/bullet-check.svg"
                  loading="lazy"
                  width={25}
                  height={25}
                />
                Conversion rates by agent, stage, and source
              </li>
              <li className="flex gap-x-[11px]">
                {" "}
                <StaticImage
                  src="../../images/1.0 Homepage/bullet-check.svg"
                  loading="lazy"
                  width={25}
                  height={25}
                />
                ROI tracking and analysis
              </li>
              <li className="flex gap-x-[11px]">
                {" "}
                <StaticImage
                  src="../../images/1.0 Homepage/bullet-check.svg"
                  loading="lazy"
                  width={25}
                  height={25}
                />
                Contact-to-closing time frame breakdowns
              </li>
            </ul>

            <ButtonSolid
              // modal="modal-contact"
              href="/free-trial"
              text="Start Free Trial"
              altStyle={2}
              className=""
            />
          </div>
          <div className="order-1 md:order-2">
            <StaticImage
              src="../../images/1.0 Homepage/leads-image.png"
              loading="lazy"
              objectFit="contain"
              width={709}
              height={556}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeStopLosingLeads;
